import ForgotCode from './ForgotCode';
export default ForgotCode;